export default "__VITE_ASSET__C5DQ7tBM__"